import { Component, ContentChild, Input, Output, TemplateRef, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Subscription } from 'rxjs';
import { DialogService } from '../../services/dialog/dialog.service';

@Component({
  selector: 'dialog-template',
  templateUrl: './dialog-template.component.html',
  styleUrls: ['./dialog-template.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    NgTemplateOutlet,
  ],
})
export class DialogTemplateComponent implements OnInit, OnDestroy {
  @Input() dialogId: string = '';
  @Input() header: string = '';
  @Input() headerIconClass: string = '';
  @Input() primaryBtnText: string = 'Save';
  @Input() primaryBtnSeverity: string = 'primary';
  @Input() primaryBtnDisabled: boolean = false;
  @Input() primaryBtnHidden: boolean = false;
  @Input() secondaryBtnText: string = 'Cancel';
  @Input() autoCloseSecondary: boolean = true;
  @Input() width: string = '40rem';
  @Input() appendTo: string;
  @Output() primaryBtnClicked = new EventEmitter();
  @Output() secondaryBtnClicked = new EventEmitter();
  @Output() closeDialog = new EventEmitter();
  @ContentChild(TemplateRef) contentTemplate: TemplateRef<unknown>;

  public dialogVisible: boolean = false;
  private dialogVisibilitySubscription: Subscription;

  constructor(private dialogService: DialogService) {}

  ngOnInit() {
    if (this.dialogId) {
      this.dialogVisibilitySubscription = this.dialogService
        .isDialogVisible(this.dialogId)
        .subscribe((visible) => {
          this.dialogVisible = visible;
        });
    }
  }

  ngOnDestroy() {
    if (this.dialogVisibilitySubscription) {
      this.dialogVisibilitySubscription.unsubscribe();
    }
  }

  public primaryBtnEvent() {
    this.primaryBtnClicked.emit();
  }

  public secondaryBtnEvent() {
    if (this.autoCloseSecondary && this.dialogId) {
      this.dialogService.closeDialog(this.dialogId);
      this.closeDialog.emit();
    }
    this.secondaryBtnClicked.emit();
  }

  public hiddenEvent() {
    if (this.dialogId) {
      this.dialogService.closeDialog(this.dialogId);
      this.closeDialog.emit();
    }
  }
}
